import React, { Component } from 'react';
import { RadioGroup, Radio } from 'react-radio-group';
import { Dropdown, DropdownToggle, DropdownMenu, Label } from 'reactstrap';

import Toggler from '../../../components/UI/Toggler';
import { categories } from '../../../constants/trekDayConstants';

// CSS
import './filter.css';

export default class Filters extends Component {
  state = { selectedValue: 'all' };

  render() {
    const { selectedValue } = this.state;

    return (
      <Toggler>
        {({ on, toggle }) => {
          this.toggle = toggle;

          return (
            <Dropdown
              isOpen={on}
              toggle={toggle}
              className="dp-plain filter"
              direction="down"
            >
              <DropdownToggle>
                <span>Filter</span> <i className="icon icon-hg-filter" />
              </DropdownToggle>
              <DropdownMenu right>
                <div className="filter-list">
                  <RadioGroup
                    name="filter-sighting"
                    selectedValue={selectedValue}
                    onChange={e => this.handleChange(e)}
                  >
                    <ul>
                      {categories.map(item => (
                        <li key={item}>
                          <Label key={categories}>
                            <Radio value={item} />
                            <span />
                            {item}
                          </Label>
                        </li>
                      ))}
                    </ul>
                  </RadioGroup>
                </div>
              </DropdownMenu>
            </Dropdown>
          );
        }}
      </Toggler>
    );
  }

  handleChange = newChanges => {
    const { limit, searchTerm } = this.props.configs;

    this.setState({ selectedValue: newChanges });

    this.toggle();

    this.props.getThemesByCategories({
      categories: newChanges,
      page: 1,
      limit,
      searchTerm,
    });
  };
}



// WEBPACK FOOTER //
// ./src/screens/Places/Filters/Filters.jsx